var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"slider__slide",style:({ padding: `0 ${this.padding}px` }),attrs:{"aria-current":_vm.current},on:{"click":function($event){_vm.buynowOnChange(), _vm.emptyInventory();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }